module.exports = __webpack_public_path__ + "img/1c.c26a820c.svg";